import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'
import { BrowserRouter } from 'react-router-dom'
import ReactGA from 'react-ga'

import * as serviceWorker from './serviceWorker'

// Only initialize Google Analytics if tracking code is provided
if (process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_CODE) {
  ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_CODE)
}

const root = createRoot(document.getElementById('root'))
root.render(
  <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <App />
  </BrowserRouter>
)

serviceWorker.register()
